import { useEffect, useState } from "react";

export interface ClientPrincipal {
  identityProvider: string;
  userId: string;
  userDetails: string;
  userRoles: string[];
}

export function useUser() {
  const [user, setUser] = useState<ClientPrincipal | null | undefined>(undefined);
  useEffect(() => {
    fetch("/.auth/me")
      .then((r) => r.json())
      .then((d) => setUser(d.clientPrincipal ?? null))
      .catch(() => setUser(null));
  }, []);
  return user;
}
